import listenerMiddleware from "App/listenerMiddleware";
import { actionTypes as signalRActionTypes } from "Areas/SharedFeatures/signalRMiddleware";
import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import keyBy from "lodash/keyBy";
import pick from "lodash/pick";
import { v4 as uuid } from "uuid";
import { NAMESPACE } from "../constants";
import actionCreators from "./actionCreators";
import actionTypes from "./actionTypes";
import reduxStoreExternal from "./reduxStoreExternal";
import { getSummaryReportId } from "./selectors";
export const initialState = {
    [NAMESPACE]: {
        dataKey: {}
    }
};
export default createReducer(initialState, {
    [actionTypes.SET_SUMMARY_REPORT_OBJECTS]: (state, { data, summaryReportId }) => {
        reduxStoreExternal.summaryReportObjects[summaryReportId] = keyBy(data, "Id");
        return set(state, `[${NAMESPACE}].dataKey[${summaryReportId}]`, uuid());
    },
    [actionTypes.CLEAR_DATA]: (state, { exceptSummaryReportId }) => {
        if (exceptSummaryReportId) {
            reduxStoreExternal.summaryReportObjects = pick(reduxStoreExternal.summaryReportObjects, exceptSummaryReportId);
            return {
                ...state,
                [NAMESPACE]: {
                    ...state[NAMESPACE],
                    dataKey: pick(state[NAMESPACE].dataKey, exceptSummaryReportId)
                }
            };
        }
        reduxStoreExternal.summaryReportObjects = {};
        return {
            ...state,
            ...initialState
        };
    },
    [actionTypes.GET_SUMMARY_REPORT_OBJECT_COMPLETED]: (state, { payload, meta }) => {
        if (reduxStoreExternal.summaryReportObjects[meta.summaryReportId]) {
            reduxStoreExternal.summaryReportObjects[meta.summaryReportId][payload.Id] = payload;
            return set(state, `[${NAMESPACE}].dataKey[${meta.summaryReportId}]`, uuid());
        }
        return state;
    }
});
listenerMiddleware.addListener({
    [signalRActionTypes.SUMMARY_REPORT_OBJECT_ADDED.redux]: ({ message }, dispatch, getState) => {
        const currentSummaryReportId = getSummaryReportId(getState());
        if (currentSummaryReportId === (message === null || message === void 0 ? void 0 : message.summaryReportId) && (message === null || message === void 0 ? void 0 : message.summaryReportObjectId)) {
            dispatch(actionCreators.getSummaryReportObject(message.summaryReportId, message.summaryReportObjectId));
        }
    },
    [actionTypes.GET_SUMMARY_REPORT_OBJECTS_COMPLETED]: (action, dispatch, getState) => {
        const currentSummaryReportId = getSummaryReportId(getState());
        dispatch(actionCreators.clearData(currentSummaryReportId));
        if (currentSummaryReportId === action.meta.summaryReportId) {
            dispatch({
                type: actionTypes.SET_SUMMARY_REPORT_OBJECTS,
                data: action.payload,
                summaryReportId: action.meta.summaryReportId
            });
        }
    }
});
